<template>
  <div>
    <!-- <button @click="test">holaaaaaa</button> -->
    <!-- <button @click="getPlansCatalogs()">holaaaaaa</button> -->
    <h2>Bienvenido al creador de planes y turnos</h2>

    <!-- NATIVE WIZARD -->
    <div
      v-if="!wizardOnDisplay"
      class="d-flex flex-row justify-content-around wizard-btns px-2 pt-4 wizard-buttons-responsive"
    >
      <button class="btn btn-success" @click="initPlansWizard('plan')">
        CREAR PLAN
      </button>
      <button class="btn btn-success" @click="initPlansWizard('family')">
        CREAR FAMILIA
      </button>
      <button class="btn btn-success" @click="initPlansWizard('subfamily')">
        CREAR SUB-FAMILIA
      </button>
      <button class="btn btn-success" @click="modals.newShiftModal = true">
        CREAR TURNO
      </button>
    </div>
    <div id="cancelFAB" class="d-block position-absolute" v-else>
      <div
        class="rounded-circle text-light bg-warning d-flex card"
        style="width: 50px; height: 50px; cursor: pointer"
        @click="wizardOnDisplay = false"
      >
        <i class="fa fa-arrow-left fa-3x m-auto" aria-hidden="true"></i>
      </div>
    </div>

    <div
      v-if="wizardOnDisplay === 'plans'"
      class="row d-flex justify-content-center"
    >
      <div class="col-md-10 mr-auto ml-auto">
        <wizard
          @complete="wizardComplete"
          ref="plansWizard"
          :prevButtonText="`Atras`"
          :nextButtonText="`Siguiente`"
          :finishButtonText="`CREAR`"
          :changeIndex.sync="changeWizardIndex"
        >
          <template v-slot:header>
            <h3 class="card-title wizard-title">Creación de Planes</h3>
            <h3 class="description wizard-description">
              Esta información nos permitirá saber más sobre tus planes.
            </h3>
          </template>

          <wizard-tab
            :before-change="() => validateStep('step1')"
            class="my-auto"
          >
            <template v-slot:label>
              <i class="fa fa-code-fork" aria-hidden="true"></i>
              <span class="wizard-step-title">Familia</span>
            </template>
            <div ref="step1" class="wizard-plans my-auto">
              <div
                class="wizard-plans-fam d-flex flex-row justify-content-between my-auto"
              >
                <div class="col d-flex flex-column">
                  <h4 class="mt-auto mb-0 mx-auto">Selecciona una familia</h4>
                  <h4 class="mx-auto my-0">o</h4>
                  <div class="mb-auto mx-auto px-0">
                    <button
                      @click="showSwal('familys', true)"
                      type="button"
                      class="btn btn-success mx-auto"
                    >
                      CREA UNA NUEVA
                    </button>
                  </div>
                </div>
                <div class="col table-container">
                  <div
                    class="table table-hover col mb-0 bg-warning rounded-top"
                  >
                    <thead>
                      <tr class="">
                        <th scope="col-1">#</th>
                        <th scope="col-10">Nombre</th>
                      </tr>
                    </thead>
                  </div>
                  <div class="table card table-hover col table-body">
                    <tbody class="table-body">
                      <tr
                        v-for="(family, index) in familys"
                        :key="index"
                        style="cursor: pointer"
                      >
                        <th
                          @click="planCreatorSaveFamily(family)"
                          class="col-1"
                          scope="row"
                        >
                          {{ family.id }}
                        </th>
                        <td
                          @click="planCreatorSaveFamily(family)"
                          class="col-10"
                        >
                          {{ family.nombre }}
                        </td>
                        <td class="col-1">
                          <i
                            role="button"
                            class="fa fa-trash-o fa-2x"
                            @click="deleteFamily(family._id)"
                            aria-hidden="true"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </div>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step2')"
            class="my-auto"
          >
            <template v-slot:label>
              <i class="fa fa-code-fork" aria-hidden="true"></i>
              <span class="wizard-step-title">Sub-Familia</span>
            </template>
            <div ref="step2" class="wizard-plans my-auto">
              <div
                class="wizard-plans-subfam d-flex flex-row justify-content-between"
              >
                <div class="col d-flex flex-column">
                  <h4 class="mt-auto mb-0 mx-auto">
                    Selecciona una sub-familia
                  </h4>
                  <h4 class="mx-auto my-0">o</h4>
                  <div class="mb-auto mx-auto px-0">
                    <button
                      type="button"
                      class="btn btn-success mx-auto"
                      @click="showSwal('subfamilys', true)"
                    >
                      CREA UNA NUEVA
                    </button>
                  </div>
                </div>

                <div class="col table-container">
                  <div
                    class="table table-hover col mb-0 bg-warning rounded-top"
                  >
                    <thead>
                      <tr class="text-light">
                        <th scope="col-1">#</th>
                        <th scope="col-10">Nombre</th>
                      </tr>
                    </thead>
                  </div>
                  <div class="table table-hover card col table-body">
                    <tbody class="table-body">
                      <tr
                        v-for="(subFamily, index) in subFamilys"
                        :key="index"
                        style="cursor: pointer"
                      >
                        <th
                          @click="planCreatorSaveSubFamily(subFamily)"
                          class="col-1"
                          scope="row"
                        >
                          {{ subFamily.id }}
                        </th>
                        <td
                          @click="planCreatorSaveSubFamily(subFamily)"
                          class="col-10"
                        >
                          {{ subFamily.nombre }}
                        </td>
                        <td class="col-1">
                          <i
                            role="button"
                            class="fa fa-trash-o fa-2x"
                            @click="deleteSubFamily(subFamily.id)"
                            aria-hidden="true"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </div>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step3')">
            <template v-slot:label>
              <i class="fa fa-clock-o" aria-hidden="true"></i>
              <span class="wizard-step-title">Turno</span>
            </template>
            <div ref="step3" class="wizard-plans my-auto">
              <div
                class="wizard-plans-shift d-flex flex-row justify-content-between"
              >
                <div class="col d-flex flex-column">
                  <div class="mx-auto my-auto text-center">
                    <h4 class="mt-auto mb-0 mx-auto">Selecciona un turno</h4>
                    <h4 class="mx-auto my-0">o</h4>
                    <div class="mb-auto mx-auto px-0">
                      <button
                        type="button"
                        class="btn btn-success mx-auto"
                        @click="modals.newShiftModal = true"
                      >
                        CREA UNO NUEVO
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col table-container">
                  <table class="table table-hover col mb-0">
                    <thead class="bg-warning rounded-top">
                      <tr class="text-light">
                        <th scope="col-1">#</th>
                        <th scope="col-10">Nombre</th>
                      </tr>
                    </thead>
                  </table>
                  <div class="table table-hover col card table-body">
                    <tbody class="table-body">
                      <tr
                        v-for="(shift, index) in shifts"
                        :key="index"
                        style="cursor: pointer"
                      >
                        <th
                          @click="planCreatorSaveShift(shift)"
                          class="col-1"
                          scope="row"
                        >
                          {{ shift.id }}
                        </th>
                        <td @click="planCreatorSaveShift(shift)" class="col-9">
                          {{ shift.descripcionTurno }}
                        </td>
                        <td
                          class="col-1"
                          @click="showPlanWizardShiftDetail(shift.id)"
                        >
                          <i class="fa fa-search col"></i>
                        </td>
                        <td class="col-1">
                          <i
                            role="button"
                            class="fa fa-trash-o fa-2x"
                            @click="deleteShift(shift.id)"
                            aria-hidden="true"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </div>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step4')">
            <template v-slot:label>
              <i class="nc-icon nc-pin-3"></i>
              <span class="wizard-step-title">Plan</span>
            </template>
            <div ref="step4" class="wizard-plans">
              <div class="wizard-plans-create card-body py-0">
                <form>
                  <div class="row">
                    <div class="col">
                      <fg-input
                        type="text"
                        label="Familia"
                        placeholder="No Seleccionado"
                        v-model="newPlanProps.famName"
                        :readonly="true"
                      >
                      </fg-input>
                    </div>
                    <div class="col">
                      <fg-input
                        type="text"
                        label="Sub-familia"
                        placeholder="No Seleccionado"
                        v-model="newPlanProps.subFamName"
                        :readonly="true"
                      >
                      </fg-input>
                    </div>
                    <div class="col">
                      <fg-input
                        type="text"
                        label="Turno"
                        placeholder="No Seleccionado"
                        v-model="newPlanProps.shiftName"
                        :readonly="true"
                      >
                      </fg-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5 my-auto">
                      <label for="">Nombre</label>
                      <input
                        type="text"
                        class="form-control"
                        label="Nombre"
                        size="small"
                        inputClasses="text-uppercase"
                        placeholder="Nuevo plan..."
                        v-model="newPlan.descripcion"
                        :readonly="enableNewPlanForm"
                      />
                    </div>
                    <div class="col-3 my-auto">
                      <small
                        ><p class="mb-1" style="color: #9a9a9a">
                          Tipo de plan
                        </p></small
                      >
                      <el-select
                        size="small"
                        v-model="newPlan.convenio"
                        placeholder="Selecciona"
                        class="success"
                        :disabled="enableNewPlanForm"
                      >
                        <el-option
                          v-for="(cat, index) in plansCatalogs.convenio"
                          :key="index"
                          :label="cat.glosa"
                          :value="cat.glosa"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col-2 my-auto d-flex">
                      <el-tooltip :open-delay="200" placement="top">
                        <template v-if="newPlan.multiSede" #content
                          >El plan permitira el ingreso<br />en todas las
                          sucursales
                        </template>
                        <template v-else #content>
                          El plan sólo permitira el ingreso <br />
                          en la sucursal donde fue asignado
                        </template>
                        <div class="switch d-flex flex-column text-center">
                          <small
                            ><p class="mb-1 mx-auto text-nowrap text-muted">
                              Multi-Sede
                            </p></small
                          >
                          <p-switch
                            v-model="newPlan.multiSede"
                            type="success"
                            class="mx-auto"
                            on-text="SI"
                            off-text="NO"
                            :readonly="enableNewPlanForm"
                          ></p-switch>
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="col-2 my-auto d-flex">
                      <el-tooltip :open-delay="200" placement="top">
                        <template v-if="newPlan.habilitarVenta" #content>
                          El plan creado quedará disponible para su venta en
                          recepción o asignación
                        </template>
                        <template v-else #content>
                          El plan creado NO estará disponible para su venta en o
                          asignación recepción
                        </template>
                        <div class="switch d-flex flex-column text-center">
                          <small
                            ><p class="mb-1 mx-auto text-nowrap text-muted">
                              Habilitado
                            </p></small
                          >
                          <p-switch
                            v-model="newPlan.habilitarVenta"
                            type="success"
                            class="mx-auto"
                            on-text="SI"
                            off-text="NO"
                            :readonly="enableNewPlanForm"
                          ></p-switch>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="valor">Valor</label>
                      <input
                        type="number"
                        label="Valor"
                        placeholder="$0..."
                        class="form-control"
                        min="0"
                        id="valor"
                        @input="validatePositive"
                        v-model="newPlan.valor"
                        :readonly="enableNewPlanForm"
                      />
                    </div>
                    <div class="col-2 my-auto">
                      <small
                        ><p class="mb-1" style="color: #9a9a9a">
                          Descuento
                        </p></small
                      >
                      <el-select
                        size="small"
                        v-model="selectedDiscount"
                        placeholder="Selecciona"
                        class="success"
                        :disabled="enableNewPlanForm"
                      >
                        <el-option
                          v-for="(amount, index) in discounts"
                          :key="index"
                          :value="amount"
                          >{{ amount }}%</el-option
                        >
                      </el-select>
                    </div>
                    <div class="col my-auto">
                      <div class="switch d-flex flex-column text-center">
                        <small
                          ><p class="mb-1 mx-auto text-nowrap text-muted">
                            Matricula
                          </p></small
                        >
                        <p-switch
                          v-model="newPlan.indicadorMatricula"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="enableNewPlanForm"
                        ></p-switch>
                      </div>
                    </div>
                    <div v-if="newPlan.indicadorMatricula" class="col">
                      <label for="">Valor Matricula</label>
                      <input
                        type="number"
                        label="Valor Matricula"
                        class="form-control"
                        id="valorMatricula"
                        @input="validatePositive"
                        placeholder="$0..."
                        min="0"
                        v-model="newPlan.valorMatricula"
                        :readonly="enableNewPlanForm"
                      />
                    </div>
                    <div class="col my-auto">
                      <small
                        ><p class="mb-1" style="color: #9a9a9a">IVA</p></small
                      >
                      <el-select
                        size="small"
                        v-model="newPlan.tipoIVA"
                        placeholder="Selecciona"
                        class="success"
                        :disabled="enableNewPlanForm"
                      >
                        <el-option label="EXENTO" value="EXENTO"></el-option>
                        <el-option label="AFECTO" value="AFECTO"></el-option>
                      </el-select>
                    </div>
                    <div class="col my-auto">
                      <div class="switch d-flex flex-column text-center">
                        <small
                          ><p class="mb-1 mx-auto text-nowrap text-muted">
                            Factura
                          </p></small
                        >
                        <p-switch
                          v-model="newPlan.indicadorFactura"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="enableNewPlanForm"
                        ></p-switch>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3 my-auto d-flex flex-row">
                      <div class="d-flex flex-column my-auto">
                        <label for="duracion">Duración</label>
                        <input
                          type="number"
                          label="Duración"
                          class="form-control"
                          placeholder=""
                          min="1"
                          id="duracion"
                          @input="validatePositive"
                          v-model="newPlan.duracion"
                          :readonly="enableNewPlanForm"
                        />
                      </div>
                      <el-select
                        size="small"
                        v-model="newPlan.unidadDuracionPlan"
                        placeholder="Selecciona"
                        class="success mt-4 mb-0"
                        :disabled="enableNewPlanForm"
                      >
                        <el-option
                          el-option
                          v-for="(
                            cat, index
                          ) in plansCatalogs.unidadDuracionPlan"
                          :key="index"
                          :label="cat.glosa"
                          :value="cat.glosa"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col-2 my-auto d-flex flex-column">
                      <label for="disasPermitidoCongelar"
                        >Días para congelar</label
                      >
                      <input
                        id="diasPermitidoCongelar"
                        @input="validatePositive"
                        v-model="newPlan.diasPermitidoCongelar"
                        type="number"
                        class="form-control"
                        label="Dias a congelar"
                        size="small"
                        placeholder=""
                        min="0"
                        :readonly="enableNewPlanForm"
                      />
                    </div>
                    <div class="col my-auto">
                      <div class="switch d-flex flex-column text-center">
                        <small
                          ><p class="mb-1 text-nowrap text-muted">
                            Plan Sesiones
                          </p></small
                        >
                        <p-switch
                          v-model="newPlan.indicadorUsoSesiones"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="enableNewPlanForm"
                        ></p-switch>
                      </div>
                    </div>
                    <div
                      v-if="newPlan.indicadorUsoSesiones"
                      class="col-5 col-md my-auto"
                    >
                      <label for="sesionesLimite">Cant. Sesiones</label>
                      <input
                        type="number"
                        label="Cant Sesiones"
                        class="form-control"
                        size="small"
                        id="sesionesLimite"
                        min="0"
                        @input="validatePositive"
                        placeholder=""
                        v-model="newPlan.sesionesLimite"
                        :readonly="enableNewPlanForm"
                      />
                    </div>
                    <div class="col my-auto">
                      <div class="switch d-flex flex-column text-center">
                        <small
                          ><p class="mb-2 mx-auto text-nowrap text-muted">
                            Mes Calendario
                          </p></small
                        >
                        <p-switch
                          v-model="newPlan.indicadorMesCalendario"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="enableNewPlanForm"
                        ></p-switch>
                      </div>
                    </div>
                    <el-tooltip :open-delay="200" placement="top">
                      <template #content>
                        Esta opción te permite personalizar la duración del
                        mes<br />
                        Por ejemplo, al seleccionar 30 días, <br />
                        todos los meses tendrán la misma duración de 30 días.
                      </template>
                      <div v-if="newPlan.indicadorMesCalendario" class="col">
                        <label for="diasMesNoCalendario">Días del mes</label>
                        <input
                          type="number"
                          label="Días del mes"
                          v-model="newPlan.diasMesNoCalendario"
                          class="form-control"
                          id="diasMesNoCalendario"
                          @input="validatePositive"
                          min="0"
                          placeholder=""
                          :readonly="enableNewPlanForm"
                        />
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="d-flex justify-content-start mt-1 px-0 mx-0">
                    <div class="col-2 my-auto pl-0 mr-2">
                      <div class="switch d-flex flex-column text-center">
                        <small
                          ><p class="mb-2 text-nowrap text-muted">
                            Plan Temporal
                          </p></small
                        >
                        <p-switch
                          v-model="newPlan.indicadorVigenciaTemporal"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="enableNewPlanForm"
                        ></p-switch>
                      </div>
                    </div>
                    <div
                      v-if="newPlan.indicadorVigenciaTemporal"
                      class="col-3 my-auto d-flex flex-column mr-2"
                    >
                      <label for="datePickerfechaAsignacion">Fecha Desde</label>
                      <el-date-picker
                        id="datePickerfechaAsignacion"
                        type="date"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="newPlan.fechaInicioVigencia"
                        :readonly="enableNewPlanForm"
                      >
                      </el-date-picker>
                      <label for="datePickerfechaAsignacion">Fecha Hasta</label>
                      <el-date-picker
                        id="datePickerfechaAsignacion"
                        type="date"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="newPlan.fechaTerminoVigencia"
                        :readonly="enableNewPlanForm"
                      >
                      </el-date-picker>
                    </div>

                    <div class="col-2 my-auto mr-2">
                      <div class="switch d-flex flex-column text-center">
                        <small
                          ><p class="mb-1 text-nowrap text-muted">
                            ¿Permite Renovar?
                          </p></small
                        >
                        <p-switch
                          v-model="newPlan.indicadorPermiteRenovar"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="enableNewPlanForm"
                        ></p-switch>
                      </div>
                    </div>
                    <div
                      v-if="newPlan.indicadorPermiteRenovar"
                      class="my-auto d-flex flex-row"
                      :class="{
                        'col-3':
                          newPlan.unidadExpiracionRenovacion ===
                          'INDEFINIDA (I)',
                        'col-4':
                          newPlan.unidadExpiracionRenovacion !==
                          'INDEFINIDA (I)',
                      }"
                    >
                      <div
                        class="my-auto col-4"
                        v-if="
                          newPlan.unidadExpiracionRenovacion !==
                          'INDEFINIDA (I)'
                        "
                      >
                        <label for="expiracionRenovacion">Expiración</label>
                        <input
                          type="number"
                          label="Expiración"
                          id="expiracionRenovacion"
                          v-model="newPlan.expiracionRenovacion"
                          class="form-control"
                          placeholder=""
                          @input="validatePositive"
                          min="1"
                          :readonly="enableNewPlanForm"
                        />
                      </div>
                      <el-select
                        size="small"
                        v-model="newPlan.unidadExpiracionRenovacion"
                        placeholder="Selecciona"
                        class="success mt-4 mb-0"
                        :disabled="enableNewPlanForm"
                      >
                        <el-option
                          el-option
                          v-for="(
                            cat, index
                          ) in plansCatalogs.unidadExpiracionRenovacion"
                          :key="index"
                          :label="cat.glosa"
                          :value="cat.glosa"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col text-center p-0">
                      <label for=""
                        >Puntos de Venta<i
                          v-if="newPlan.sucursalesHabilitadas.length === 0"
                          class="fa fa-exclamation-triangle fa-1x text-danger"
                        ></i
                      ></label>

                      <fg-input>
                        <el-select
                          size="small"
                          multiple
                          :class="{
                            'select-success':
                              newPlan.sucursalesHabilitadas.length > 0,
                            'select-danger':
                              newPlan.sucursalesHabilitadas.length === 0,
                          }"
                          v-model="selects.multiple"
                          :placeholder="
                            newPlan.sucursalesHabilitadas.length > 0
                              ? 'Sucursales'
                              : 'Debes seleccionar al menos uno'
                          "
                        >
                          <el-option
                            v-for="option in branches"
                            class="select-primary"
                            :value="JSON.stringify(option)"
                            :label="option.nombreSucursal"
                            :key="option._id"
                          >
                          </el-option>
                        </el-select>
                      </fg-input>
                    </div>
                  </div>
                </form>
                <div class="d-flex mt-2">
                  <p-button
                    class="ml-auto mr-4"
                    type="success"
                    :disabled="enableNewPlanForm"
                    @click="handleNewPlanSave()"
                    >CREAR</p-button
                  >
                  <p-button
                    class="mr-auto"
                    type="danger"
                    @click="cancelPlansWizard()"
                    >CANCELAR</p-button
                  >
                </div>
              </div>
            </div>
          </wizard-tab>
        </wizard>
      </div>
    </div>
    <div
      v-if="wizardOnDisplay === 'family'"
      class="card wizard-plans my-auto p-4 w-75 mx-auto"
    >
      <div
        class="wizard-plans-fam d-flex flex-row justify-content-between my-auto"
      >
        <div class="col d-flex flex-column">
          <div class="mb-auto m-auto px-0">
            <button
              @click="showSwal('familys')"
              type="button"
              class="btn btn-success mx-auto"
            >
              CREA UNA familia
            </button>
          </div>
        </div>
        <div class="col table-container">
          <div class="table table-hover col mb-0 bg-warning rounded-top">
            <thead>
              <tr class="">
                <th scope="col-1">#</th>
                <th scope="col-10">Familias Creadas</th>
              </tr>
            </thead>
          </div>
          <div class="table card table-hover col table-body">
            <tbody class="table-body">
              <tr
                v-for="(family, index) in familys"
                :key="index"
                style="cursor: pointer"
              >
                <th class="col-1" scope="row">
                  {{ family.id }}
                </th>
                <td class="col-10">
                  {{ family.nombre }}
                </td>
                <td class="col-1">
                  <i
                    role="button"
                    class="fa fa-trash-o fa-2x"
                    @click="deleteFamily(family._id)"
                    aria-hidden="true"
                  ></i>
                </td>
              </tr>
            </tbody>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="wizardOnDisplay === 'subfamily'"
      class="row d-flex justify-content-center"
    >
      <div class="col-md-10 mr-auto ml-auto">
        <wizard
          ref="plansWizard"
          :prevButtonText="`Atras`"
          :nextButtonText="`siguiente`"
          :finishButtonText="`FINALIZAR`"
        >
          <template v-slot:header>
            <h3 class="card-title">Build your profile</h3>
            <h3 class="description">
              This information will let us know more about you.
            </h3>
          </template>

          <wizard-tab
            :before-change="() => validateStep('step1')"
            class="my-auto"
          >
            <template v-slot:label>
              <i class="fa fa-code-fork" aria-hidden="true"></i>
              Familia
            </template>
            <div ref="step1" class="wizard-plans my-auto">
              <div
                class="wizard-plans-fam d-flex flex-row justify-content-between my-auto"
              >
                <div class="col d-flex flex-column">
                  <h4 class="mt-auto mb-0 mx-auto">Selecciona una familia</h4>
                  <h4 class="mx-auto my-0">o</h4>
                  <div class="mb-auto mx-auto px-0">
                    <button
                      @click="showSwal('familys', false)"
                      type="button"
                      class="btn btn-success mx-auto"
                    >
                      CREA UNA NUEVA
                    </button>
                  </div>
                </div>
                <div class="col table-container">
                  <div
                    class="table table-hover col mb-0 bg-warning rounded-top"
                  >
                    <thead>
                      <tr class="">
                        <th scope="col-1">#</th>
                        <th scope="col-10">Nombre</th>
                      </tr>
                    </thead>
                  </div>
                  <div class="table card table-hover col table-body">
                    <tbody class="table-body">
                      <tr
                        v-for="(family, index) in familys"
                        :key="index"
                        style="cursor: pointer"
                      >
                        <th
                          @click="planCreatorSaveFamily(family)"
                          class="col-1"
                          scope="row"
                        >
                          {{ family.id }}
                        </th>
                        <td
                          @click="planCreatorSaveFamily(family)"
                          class="col-10"
                        >
                          {{ family.nombre }}
                        </td>
                        <td class="col-1">
                          <i
                            role="button"
                            class="fa fa-trash-o fa-2x"
                            @click="deleteFamily(family._id)"
                            aria-hidden="true"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </div>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step2')"
            class="my-auto"
          >
            <template slot="label">
              <i class="fa fa-code-fork" aria-hidden="true"></i>
              Sub-Familia
            </template>
            <div ref="step2" class="wizard-plans my-auto">
              <div
                class="wizard-plans-subfam d-flex flex-row justify-content-between"
              >
                <div class="col d-flex flex-column">
                  <h4 class="mt-auto mb-0 mx-auto">
                    Selecciona una sub-familia
                  </h4>
                  <h4 class="mx-auto my-0">o</h4>
                  <div class="mb-auto mx-auto px-0">
                    <button
                      type="button"
                      class="btn btn-success mx-auto"
                      @click="showSwal('subfamilys', false)"
                    >
                      CREA UNA NUEVA
                    </button>
                  </div>
                </div>

                <div class="col table-container">
                  <div
                    class="table table-hover col mb-0 bg-warning rounded-top"
                  >
                    <thead>
                      <tr class="text-light">
                        <th scope="col-1">#</th>
                        <th scope="col-10">Nombre</th>
                      </tr>
                    </thead>
                  </div>
                  <div class="table table-hover card col table-body">
                    <tbody class="table-body">
                      <tr
                        v-for="(subFamily, index) in subFamilys"
                        :key="index"
                        style="cursor: pointer"
                      >
                        <th class="col-1" scope="row">
                          {{ subFamily.id }}
                        </th>
                        <td class="col-10">
                          {{ subFamily.nombre }}
                        </td>
                        <td class="col-1">
                          <i
                            role="button"
                            class="fa fa-trash-o fa-2x"
                            @click="deleteSubFamily(subFamily.id)"
                            aria-hidden="true"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </div>
                </div>
              </div>
            </div>
          </wizard-tab>
        </wizard>
      </div>
    </div>
    <div
      v-if="wizardOnDisplay === 'shift'"
      class="card wizard-plans my-auto p-4 w-75 mx-auto"
    >
      <div
        class="wizard-plans-fam d-flex flex-row justify-content-between my-auto"
      >
        <div class="col d-flex flex-column">
          <div class="mb-auto m-auto px-0">
            <button
              @click="modals.newShiftModal = true"
              type="button"
              class="btn btn-success mx-auto"
            >
              CREA UN turno
            </button>
          </div>
        </div>
        <div class="col table-container">
          <table class="table table-hover col mb-0">
            <thead class="bg-warning rounded-top">
              <tr class="text-light">
                <th scope="col-1">#</th>
                <th scope="col-10">Nombre</th>
              </tr>
            </thead>
          </table>
          <div class="table table-hover col card table-body">
            <tbody class="table-body">
              <tr
                v-for="(shift, index) in shifts"
                :key="index"
                style="cursor: pointer"
              >
                <th class="col-1" scope="row">
                  {{ shift.id }}
                </th>
                <td class="col-9">
                  {{ shift.descripcionTurno }}
                </td>
                <td class="col-1" @click="showPlanWizardShiftDetail(shift.id)">
                  <i class="fa fa-search col"></i>
                </td>
                <td class="col-1">
                  <i
                    role="button"
                    class="fa fa-trash-o fa-2x"
                    @click="deleteShift(shift.id)"
                    aria-hidden="true"
                  ></i>
                </td>
              </tr>
            </tbody>
          </div>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.planWizardShiftDetail"
      footerClasses="justify-content-center"
      type="notice"
    >
      <template v-slot:header>
        <h5 class="modal-title font-weight-bold">
          {{ modals.planWizardShiftDetailData.descripcionTurno || "Prueba" }}
        </h5>
      </template>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Lunes</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.lunesAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.lunesAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.lunesAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.lunesHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino {{ modals.planWizardShiftDetailData.lunesHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Martes</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.martesAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.martesAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.martesAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.martesHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino {{ modals.planWizardShiftDetailData.martesHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Miercoles</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.miercolesAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.miercolesAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.miercolesAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.miercolesHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino
            {{ modals.planWizardShiftDetailData.miercolesHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Jueves</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.juevesAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.juevesAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.juevesAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.juevesHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino {{ modals.planWizardShiftDetailData.juevesHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Viernes</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.viernesAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.viernesAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.viernesAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.viernesHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino {{ modals.planWizardShiftDetailData.viernesHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Sabado</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.sabadoAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.sabadoAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.sabadoAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.sabadoHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino {{ modals.planWizardShiftDetailData.sabadoHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-between">
          <p class="mb-0 font-weight-bold">Domingo</p>
          <i
            class="fa fa-2x"
            aria-hidden="true"
            :class="{
              'text-success fa-check-circle':
                modals.planWizardShiftDetailData.domingoAutorizado,
              'text-danger fa-times-circle':
                !modals.planWizardShiftDetailData.domingoAutorizado,
            }"
          ></i>
        </div>
        <hr class="mt-0" />
        <div
          v-if="modals.planWizardShiftDetailData.domingoAutorizado"
          class="d-flex flex-row"
        >
          <p class="mr-2">
            Inicio {{ modals.planWizardShiftDetailData.domingoHoraInicio }}Hrs
          </p>
          <p class="mr-2">-</p>
          <p class="mr-2">
            Termino {{ modals.planWizardShiftDetailData.domingoHoraTermino }}Hrs
          </p>
        </div>
        <div v-else>
          <p>Día no autorizado</p>
        </div>
      </div>
    </modal>
    <modal
      :show.sync="modals.newShiftModal"
      footerClasses="justify-content-center"
      type="notice"
      ref="shiftFastCreator"
      @close="handleShiftCreationModalClose()"
    >
      <h5 slot="header" class="modal-title">Creador rápido de turnos</h5>
      <div d-flex>
        <fg-input
          type="text"
          label="Nombre Turno"
          class="text-uppercase"
          v-model="newShift.descripcionTurno"
          placeholder=""
          :readonly="false"
        >
        </fg-input>
      </div>
      <div class="d-flex flex-row flex-wrap">
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Lunes</p>
            <p-switch
              v-model="newShift.lunesAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.lunesAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.lunesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('lunesHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.lunesAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.lunesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('lunesHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Martes</p>
            <p-switch
              v-model="newShift.martesAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.martesAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.martesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('martesHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.martesAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.martesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('martesHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Miércoles</p>
            <p-switch
              v-model="newShift.miercolesAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.miercolesAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.miercolesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('miercolesHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.miercolesAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.miercolesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('miercolesHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Jueves</p>
            <p-switch
              v-model="newShift.juevesAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.juevesAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.juevesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('juevesHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.juevesAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.juevesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('juevesHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Viernes</p>
            <p-switch
              v-model="newShift.viernesAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.viernesAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.viernesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('viernesHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.viernesAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.viernesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('viernesHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Sábado</p>
            <p-switch
              v-model="newShift.sabadoAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.sabadoAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.sabadoHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('sabadoHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.sabadoAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.sabadoHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('sabadoHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4">
            <p class="card-title">Domingo</p>
            <p-switch
              v-model="newShift.domingoAutorizado"
              type="primary"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="newShift.domingoAutorizado" class="col-md-4">
            <p class="card-title">Inicio</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.domingoHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
                @change="handleTimeChange('domingoHoraInicio')"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="newShift.domingoAutorizado" class="col-md-4">
            <p class="card-title">Fin</p>
            <div class="form-group">
              <el-time-select
                v-model="newShift.domingoHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
                @change="handleTimeChange('domingoHoraTermino')"
              >
              </el-time-select>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <p-button type="success" class="mr-2" @click="submitNewShiftModal()"
          >OK</p-button
        >
        <p-button @click="cancelNewShiftModal()" type="danger"
          >CANCELAR</p-button
        >
      </div>
    </modal>


  </div>
</template>

<script>
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
} from "element-ui";

import { Badge, Modal } from "src/components/UIComponents";
import PSwitch from "src/components/UIComponents/Switch.vue";
import FirstStep from "./Wizard/FirstStep.vue";
import SecondStep from "./Wizard/SecondStep.vue";
import ThirdStep from "./Wizard/ThirdStep.vue";
import Swal from "sweetalert2";
import { Wizard, WizardTab } from "src/components/UIComponents";
import { Tooltip } from "element-ui";
export default {
  components: {
    [Select.name]: Select,
    [Input.name]: Input,
    [Button.name]: Button,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    Modal,
    Badge,
    Swal,
    PSwitch,
    Wizard,
    WizardTab,
    FirstStep,
    SecondStep,
    ThirdStep,
    [Tooltip.name]: Tooltip,
  },
  watch: {
    selectedDiscount: function (newValue) {
      this.newPlan.porcentajeDescuento = newValue / 100;
    },
    "selects.multiple": function (newValue) {
      // console.log("newValue");
      // console.log(newValue);
      this.newPlan.sucursalesHabilitadas = newValue.map((branch) =>
        JSON.parse(branch)
      );
      // console.log("this.newPlan.sucursalesHabilitadas");
      // console.log(this.newPlan.sucursalesHabilitadas);
    },
    "newPlan.valor": function (newValue) {
      // console.log(newValue);
      // console.log(typeof newValue);
    },
    "newPlan.indicadorVigenciaTemporal": function (newValue) {
      if (this.isLoaded && !newValue) {
        this.newPlan.fechaInicioVigencia = "";
        this.newPlan.fechaTerminoVigencia = "";
      } else if (this.isLoaded && newValue) {
        this.newPlan.fechaInicioVigencia = this.$moment()
          .startOf("month")
          .format("DD-MM-YYYY");
        this.newPlan.fechaTerminoVigencia = this.$moment()
          .endOf("month")
          .format("DD-MM-YYYY");
      }
    },
    "newPlan.unidadExpiracionRenovacion": function (newValue, oldValue) {
      if (newValue === "INDEFINIDA (I)") {
        this.newPlan.expiracionRenovacion = 0;
      }
    },
    "newPlan.indicadorMesCalendario": function (newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        this.newPlan.indicadorUsoSesiones = true;
        this.newPlan.sesionesLimite = this.newPlan.sesionesLimite || 1;
        this.newPlan.diasMesNoCalendario = 0;
      } else if (newValue && newValue !== oldValue) {
        this.newPlan.diasMesNoCalendario = 0;
      }
    },
    "newPlan.indicadorUsoSesiones": function (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.newPlan.sesionesLimite = this.newPlan.sesionesLimite || 1;
      } else if (!newValue && oldValue) {
        this.newPlan.sesionesLimite = 0;
      }
    },
    "modals.planWizardShiftDetail": function (newValue) {
      if (newValue === false) {
        this.newShift = {
          lunesAutorizado: false,
          martesAutorizado: false,
          miercolesAutorizado: false,
          juevesAutorizado: false,
          viernesAutorizado: false,
          sabadoAutorizado: false,
          domingoAutorizado: false,
          descripcionTurno: "",
          lunesHoraInicio: "00:00:00",
          lunesHoraTermino: "00:00:00",
          martesHoraInicio: "00:00:00",
          martesHoraTermino: "00:00:00",
          miercolesHoraInicio: "00:00:00",
          miercolesHoraTermino: "00:00:00",
          juevesHoraInicio: "00:00:00",
          juevesHoraTermino: "00:00:00",
          viernesHoraInicio: "00:00:00",
          viernesHoraTermino: "00:00:00",
          sabadoHoraInicio: "00:00:00",
          sabadoHoraTermino: "00:00:00",
          domingoHoraInicio: "00:00:00",
          domingoHoraTermino: "00:00:00",
          id: 0,
        };
      }
    },
    "newPlanProps.famName": function (newValue) {
      this.validatePlanForm();
    },
    "newPlanProps.subFamName": function (newValue) {
      this.validatePlanForm();
    },
    "newPlanProps.shiftName": function (newValue) {
      this.validatePlanForm();
    },
  },
  computed: {
    // parsedDiscount(){
    //   return this.selectedDiscount / 100
    // }
  },
  data() {
    return {
      changeWizardIndex: 0,
      selectedDiscount: 0,
      discounts: [
        0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85,
        90, 95, 100,
      ],
      selects: { multiple: [] },
      wizardModel: {},
      wizardOnDisplay: "",
      famSelect: [{ label: `Crear nueva familia...`, value: 0 }],
      selectedFam: "",
      createFam: "",
      selectedSubFam: {},
      selectedShift: {},
      modals: {
        planWizardShiftDetail: false,
        planWizardShiftDetailData: {
          _id: "",
          // empresa: "", Datos a tomar en el endpoint al momento de la insersión para utilizar autenticación
          // nombreEmpresa: "2Tec Sistemas",
          lunesAutorizado: false,
          martesAutorizado: false,
          miercolesAutorizado: false,
          juevesAutorizado: false,
          viernesAutorizado: false,
          sabadoAutorizado: false,
          domingoAutorizado: false,
          descripcionTurno: "",
          lunesHoraInicio: "",
          lunesHoraTermino: "",
          martesHoraInicio: "",
          martesHoraTermino: "",
          miercolesHoraInicio: "",
          miercolesHoraTermino: "",
          juevesHoraInicio: "",
          juevesHoraTermino: "",
          viernesHoraInicio: "",
          viernesHoraTermino: "",
          sabadoHoraInicio: "",
          sabadoHoraTermino: "",
          domingoHoraInicio: "",
          domingoHoraTermino: "",
          id: 0,
        },
        newShiftModal: false,
        loading: false,
      },
      planWizardStep: 0,
      newPlanProps: {
        famName: null,
        subFamName: null,
        shiftName: null,
      },
      newPlan: {
        idFamilia: null,
        nombreFamilia: null,
        idSubFamilia: null,
        nombreSubFamilia: null,
        descripcion: null,
        valor: 0,
        turno: {},
        // idTurno: null,
        indicadorMatricula: false,
        indicadorFactura: false,
        diasPermitidoCongelar: 0,
        duracion: 1,
        unidadDuracionPlan: null,
        convenio: null,
        porcentajeDescuento: 0,
        indicadorMesCalendario: true,
        indicadorUsoSesiones: false,
        sesionesLimite: 0,
        multiSede: false,
        sucursalesHabilitadas: [],
        valorMatricula: 0,
        indicadorVigenciaTemporal: false,
        fechaInicioVigencia: "",
        fechaTerminoVigencia: "",
        indicadorPermiteRenovar: true,
        tipoIVA: "EXENTO",
        diasMesNoCalendario: 0,
        expiracionRenovacion: 0,
        unidadExpiracionRenovacion: "INDEFINIDA (I)",
      },
      newShift: {
        lunesAutorizado: false,
        martesAutorizado: false,
        miercolesAutorizado: false,
        juevesAutorizado: false,
        viernesAutorizado: false,
        sabadoAutorizado: false,
        domingoAutorizado: false,
        descripcionTurno: "",
        lunesHoraInicio: "00:00:00",
        lunesHoraTermino: "23:59:59",
        martesHoraInicio: "00:00:00",
        martesHoraTermino: "23:59:59",
        miercolesHoraInicio: "00:00:00",
        miercolesHoraTermino: "23:59:59",
        juevesHoraInicio: "00:00:00",
        juevesHoraTermino: "23:59:59",
        viernesHoraInicio: "00:00:00",
        viernesHoraTermino: "23:59:59",
        sabadoHoraInicio: "00:00:00",
        sabadoHoraTermino: "23:59:59",
        domingoHoraInicio: "00:00:00",
        domingoHoraTermino: "23:59:59",
      },
      familys: [],
      subFamilys: [],
      shifts: [],
      plansCatalogs: {},
      enableNewPlanForm: true,
      selectedBranch: "",
      isLoaded: false,
    };
  },
  methods: {
    validatePositive(event) {
      const value = parseFloat(event.target.value);
      // console.log(event.target);
      const key = event.target.id;
      if (value < 0 || isNaN(value)) {
        this.newPlan[key] = 0;
      } else {
        this.newPlan[key] = this.newPlan[key];
      }
    },
    test() {
      console.log(this.newPlan);
    },
    async deleteFamily(id) {
      const familyId = id;
      // console.log("familyId: " + familyId);
      var isConfirmed;
      await this.$swal
        .fire({
          title: "Estas seguro?",
          text: "Tambien eliminaras todas las subfamilias!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, eliminalo!",
          cancelButtonText: "Cancelar",
        })
        .then((res) => {
          // console.log(res);
          isConfirmed = res.isConfirmed;
        });

      if (isConfirmed) {
        // console.log("Eliminando familia...");
        this.$swal.fire({
          title: "Cargando",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  id: familyId,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/delete/family",
                  // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  //   .AccessStatistics,
                },
              }
            )
            .then((resp) => {
              // console.log("resp++++++++++++++++++++");
              // console.log(resp);
              this.$swal.close();
              if (resp.data.error) {
                this.$swal.fire({
                  title: "Ha ocurrido un error :(!",
                  icon: "error",
                  text: resp.data.error,
                  showConfirmButton: true,
                  confirmButtonColor: "#6bd098",
                });
              } else {
                // console.log(resp);
                const familys = this.familys;
                this.familys = [];
                this.familys = familys.filter((fam) => fam._id !== familyId);
                this.$swal.fire({
                  title: "Exito",
                  icon: "success",
                  confirmButtonColor: "#6bd098",
                });
                // this.$router.push("#");
                // this.getFamilys();
              }
            });
        } catch (ex) {
        } finally {
          this.filters.update = true;
          return;
        }
      } else {
        console.warn("Eliminacion canselada por usuario");
      }
    },
    async deleteSubFamily(id) {
      const subSamilyId = id;
      // console.log("familyId: " + familyId);
      var isConfirmed;
      await this.$swal
        .fire({
          title: "Estas seguro?",
          text: "Esto no puede revertirse",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, eliminalo!",
          cancelButtonText: "Cancelar",
        })
        .then((res) => {
          // console.log(res);
          isConfirmed = res.isConfirmed;
        });

      if (isConfirmed) {
        // console.log("Eliminando familia...");
        this.$swal.fire({
          title: "Cargando",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  id: subSamilyId,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/delete/subfamily",
                  // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  //   .AccessStatistics,
                },
              }
            )
            .then((resp) => {
              // console.log("resp++++++++++++++++++++");
              // console.log(resp);
              this.$swal.close();
              if (resp.data.error) {
                this.$swal.fire({
                  title: "Ha ocurrido un error :(!",
                  icon: "error",
                  text: resp.data.error,
                  showConfirmButton: true,
                  confirmButtonColor: "#6bd098",
                });
              } else {
                // console.log(resp);
                this.$swal.fire({
                  title: "Exito",
                  icon: "success",
                  confirmButtonColor: "#6bd098",
                });
                // this.$router.push("#");
                this.getSubFamilys();
              }
            });

          const subFamilys = this.subFamilys;
          this.subFamilys = [];
          this.subFamilys = subFamilys.filter(
            (subFam) => subFam.id !== subSamilyId
          );
        } catch (ex) {
        } finally {
          this.filters.update = true;
          return;
        }
      } else {
        console.warn("Eliminacion cancelada por usuario");
      }
    },
    async deleteShift(id) {
      const shiftId = id;
      // console.log("familyId: " + familyId);
      var isConfirmed;
      await this.$swal
        .fire({
          title: "Estas seguro?",
          text: "Esto no puede revertirse",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, eliminalo!",
          cancelButtonText: "Cancelar",
        })
        .then((res) => {
          // console.log(res);
          isConfirmed = res.isConfirmed;
        });

      if (isConfirmed) {
        // console.log("Eliminando turno...");
        this.$swal.fire({
          title: "Cargando",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          // console.log(`Eliminando turno n°${shiftId}`);
          // console.log(`Iniciando llamada a "/v1/delete/shift"`);
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  id: shiftId,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/delete/shift",
                  // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  //   .AccessStatistics,
                },
              }
            )
            .then((resp) => {
              // console.log("resp++++++++++++++++++++");
              // console.log(resp);
              this.$swal.close();
              if (resp.data.error) {
                this.$swal.fire({
                  title: "Ha ocurrido un error :(!",
                  icon: "error",
                  text: resp.data.error,
                  showConfirmButton: true,
                  confirmButtonColor: "#6bd098",
                });
              } else {
                // console.log(resp);
                this.$swal.fire({
                  title: "Exito",
                  icon: "success",
                  confirmButtonColor: "#6bd098",
                });
                // this.$router.push("#");
                this.getSubFamilys();
              }
            });
          const shifts = this.shifts;
          this.shifts = [];

          this.shifts = shifts.filter((shift) => shift.id !== shiftId);
        } catch (ex) {
        } finally {
          this.filters.update = true;

          return;
        }
      } else {
        console.warn("Eliminacion cancelada por usuario");
      }
    },
    cancelPlansWizard() {
      this.newPlanProps = {
        famName: null,
        subFamName: null,
        shiftName: null,
      };
      this.selects = { multiple: [] };
      this.newPlan = {
        idFamilia: 0,
        nombreFamilia: "",
        idSubFamilia: 0,
        nombreSubFamilia: "",
        descripcion: "",
        valor: 0,
        turno: {},
        // idTurno: null,
        indicadorMatricula: false,
        indicadorFactura: false,
        diasPermitidoCongelar: 0,
        duracion: 0,
        unidadDuracionPlan: this.plansCatalogs.unidadDuracionPlan[0].glosa,
        convenio: this.plansCatalogs.convenio[0].glosa,
        porcentajeDescuento: 0,
        indicadorMesCalendario: true,
        indicadorUsoSesiones: false,
        sesionesLimite: 0,
        multiSede: true,
        sucursalesHabilitadas: [],
        valorMatricula: 0,
        indicadorVigenciaTemporal: false,
        fechaInicioVigencia: "",
        fechaTerminoVigencia: "",
        indicadorPermiteRenovar: true,
        tipoIVA: "EXENTO",
        diasMesNoCalendario: 0,
        expiracionRenovacion: 0,
        unidadExpiracionRenovacion:
          this.plansCatalogs.unidadExpiracionRenovacion[2].glosa,
      };
      this.newShift = {
        lunesAutorizado: false,
        martesAutorizado: false,
        miercolesAutorizado: false,
        juevesAutorizado: false,
        viernesAutorizado: false,
        sabadoAutorizado: false,
        domingoAutorizado: false,
        descripcionTurno: "",
        lunesHoraInicio: "00:00:00",
        lunesHoraTermino: "23:59:59",
        martesHoraInicio: "00:00:00",
        martesHoraTermino: "23:59:59",
        miercolesHoraInicio: "00:00:00",
        miercolesHoraTermino: "23:59:59",
        juevesHoraInicio: "00:00:00",
        juevesHoraTermino: "23:59:59",
        viernesHoraInicio: "00:00:00",
        viernesHoraTermino: "23:59:59",
        sabadoHoraInicio: "00:00:00",
        sabadoHoraTermino: "23:59:59",
        domingoHoraInicio: "00:00:00",
        domingoHoraTermino: "23:59:59",
      };
      this.familys = [];
      this.subFamilys = [];
      this.wizardOnDisplay = false;
    },
    evalNewPlanForm() {
      // console.log("evaluando cambio");
      if (
        newPlanProps.famName &&
        newPlanProps.subFamName &&
        newPlanProps.shiftName
      ) {
        this.enableNewPlanForm = false;
        // console.log("resultado: ", this.enableNewPlanForm);
      } else {
        this.enableNewPlanForm = true;
        // console.log("resultado: ", this.enableNewPlanForm);
      }
    },
    validatePlanForm() {
      // Validar que todos los campos requeridos estén completos
      if (
        this.newPlanProps.famName &&
        this.newPlanProps.subFamName &&
        this.newPlanProps.shiftName
      ) {
        this.enableNewPlanForm = false; // Habilitar el formulario
      } else {
        this.enableNewPlanForm = true; // Deshabilitar el formulario
      }
    },
    validateStep(ref) {
      // return this.$refs[ref].validate();
      return true;
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    async wizardComplete() {
      // if () {}
      // Swal.fire({
      //   title: "Good job!",
      //   text: "You clicked the finish button!",
      //   type: "success",
      //   confirmButtonClass: "btn btn-success",
      //   buttonsStyling: false,
      // });
      if (
        this.newPlanProps.famName &&
        this.newPlanProps.subFamName &&
        this.newPlanProps.shiftName
      ) {
        await this.handleNewPlanSave();
      } else {
        this.$swal.fire({
          title: "Aún no has completado todos los pasos",
          text: "Recuerda primero seleccionar un turno, familia y sub-familia para tu plan",
          type: "warning",
          icon: "warning",
          confirmButtonColor: "#6bd098",
        });
        this.cancelPlansWizard();
      }
    },
    async showPlanWizardShiftDetail(id) {
      // console.log(id);
      this.$swal.fire({
        title: "Cargando",
        text: `Guardando selección`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      var foundShift;
      try {
        // console.log("id******");
        // console.log(id);
        foundShift = await this.getShift(id);
        // console.log("foundShift********");
        // console.log(foundShift);
        this.modals.planWizardShiftDetailData = { ...foundShift };
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        this.$swal.close();

        this.modals.planWizardShiftDetail = true;
      }
    },
    async getPlansCatalogs() {
      // console.log(this.selectedShift);
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/plans/catalogs",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        if (response.data) {
          // console.log(response.data);
          this.plansCatalogs = response.data;
          this.newPlan.convenio = response.data.convenio[0].glosa;
          this.newPlan.unidadDuracionPlan =
            response.data.unidadDuracionPlan[0].glosa;
          this.newPlan.unidadExpiracionRenovacion =
            response.data.unidadExpiracionRenovacion[2].glosa;
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async getFamilys() {
      this.familys = [];
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/planfamilys",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        // console.log(response);
        if (response.data.result && response.data.result.length > 0) {
          response.data.result.forEach((family) => {
            this.familys.push(family);
          });
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async getSubFamilys(id) {
      // console.log("*****************************id");
      // console.log(id);
      this.subFamilys = [];
      var family = id || "65a826061bc95a8ddf9fc79c";
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { family: family },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/plansubfamilys",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        if (response.data.result && response.data.result.length > 0) {
          response.data.result.forEach((subFamily) => {
            this.subFamilys.push(subFamily);
          });
        } else {
          // console.log(response.data.result);
          return;
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async getShiftResum() {
      this.shifts = [];
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/shift/resum",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        // console.log("response.data.result");
        // console.log(response.data.result);
        if (response.data.result && response.data.result.length > 0) {
          response.data.result.forEach((shift) => {
            // console.log("shift*******");
            // console.log(shift);
            this.shifts.push(shift);
          });
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async getShift(id) {
      let response;
      // console.log("iniciando GetShift: ", id);
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { shift: id },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/shift",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );

        // console.log(response.data.result);
        return response.data.result;
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async planCreatorSaveFamily(fam) {
      this.$swal.fire({
        title: "Cargando",
        text: `Guardando selección`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.newPlanProps.famName = fam.nombre;
      this.newPlan.idFamilia = fam.id;
      this.newPlanProps.subFamName = null;
      this.newPlan.idSubFamilia = 0;
      const id = fam._id;
      Promise.all([this.getSubFamilys(id)]) // Asegúrate de invocar la función getSubFamilys
        .then(() => {
          this.$swal.close();
          this.selectedFam = id;
          this.$refs.plansWizard.nextTab();
        })
        .catch((error) => {
          this.$swal.close();
          console.error("Error al obtener las subfamilias:", error);
        });
    },
    async planCreatorSaveSubFamily(subfam) {
      this.$swal.fire({
        title: "Cargando",
        text: `Guardando selección`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.newPlanProps.subFamName = subfam.nombre;
      this.newPlan.idSubFamilia = subfam.id;
      Promise.all([this.getShiftResum()]) // Asegúrate de invocar la función getSubFamilys
        .then(() => {
          this.$swal.close();
          this.$refs.plansWizard.nextTab();
        })
        .catch((error) => {
          this.$swal.close();
          console.error("Error al obtener las turnos:", error);
        });
    },
    async insertFamily(name) {
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { name: name },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/insert/planfamily",
            },
          }
        );
        if (response.data.result) {
          return response.data.result;
        } else {
          console.error(response);
          this.$swal
            .fire({
              title: "Error!",
              text:
                response.data.error +
                  `. Vuelve a intentarlo más tarde o ponte en contacto con soporte.` ||
                "Ha ocurrido un error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte.",
              icon: "error",
            })
            .then((res) => {
              this.cancelPlansWizard();
            });
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
        this.$swal
          .fire({
            title: "Error!",
            text:
              error.message +
                `. Vuelve a intentarlo más tarde o ponte en contacto con soporte.` ||
              "Ha ocurrido un error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte.",
            icon: "error",
          })
          .then((res) => {
            this.cancelPlansWizard();
          });
      }
    },
    async insertSubFamily(name) {
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { name: name, family: this.selectedFam },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/insert/plansubfamily",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        // console.log(response);
        if (response.data.result) {
          return response.data.result;
        } else {
          console.error(response);
          this.$swal
            .fire({
              title: "Error!",
              text:
                response.data.error +
                  `. Vuelve a intentarlo más tarde o ponte en contacto con soporte.` ||
                "Ha ocurrido un error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte.",
              icon: "error",
            })
            .then((res) => {
              this.cancelPlansWizard();
            });
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
        this.$swal
          .fire({
            title: "Error!",
            text:
              error.message +
                `. Vuelve a intentarlo más tarde o ponte en contacto con soporte.` ||
              "Ha ocurrido un error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte.",
            icon: "error",
          })
          .then((res) => {
            this.cancelPlansWizard();
          });
      }
    },
    async insertShift(newShift) {
      let response;

      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { ...newShift },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/insert/shift",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        // console.log(response.data);
        if (response.data.result) {
          return response.data.result;
        } else {
          console.error(response);
          this.$swal
            .fire({
              title: "Error!",
              text:
                response.data.error +
                  `. Vuelve a intentarlo más tarde o ponte en contacto con soporte.` ||
                "Ha ocurrido un error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte.",
              icon: "error",
            })
            .then((res) => {
              this.cancelPlansWizard();
            });
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
        this.$swal
          .fire({
            title: "Error!",
            text:
              error.message +
                `. Vuelve a intentarlo más tarde o ponte en contacto con soporte.` ||
              "Ha ocurrido un error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte.",
            icon: "error",
          })
          .then((res) => {
            this.cancelPlansWizard();
          });
      }
    },
    planCreatorSaveShift(shift) {
      this.$swal.fire({
        title: "Cargando",
        text: `Guardando selección`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.newPlanProps.shiftName = shift.descripcionTurno;
      // this.newPlan.idTurno = shift.id;
      if (this.$refs.plansWizard) {
        this.$refs.plansWizard.nextTab();
      }
      this.selectedShift = shift;
      this.$swal.close();
    },
    initPlansWizard(wizard) {
      this.$swal.fire({
        title: "Cargando",
        text: `Iniciando creación de ${wizard}`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      switch (wizard) {
        case "plan":
          this.getFamilys() // Asegúrate de invocar la función getSubFamilys
            .then(() => {
              this.wizardOnDisplay = "plans";
              this.$swal.close();
            })
            .catch((error) => {
              this.$swal.close();
              console.error("Error al obtener las familias:", error);
            });
          break;
        case "family":
          this.getFamilys() // Asegúrate de invocar la función getSubFamilys
            .then(() => {
              this.wizardOnDisplay = "family";
              this.$swal.close();
            })
            .catch((error) => {
              this.$swal.close();
              console.error("Error al obtener las familias:", error);
            });
          break;
        case "subfamily":
          this.getFamilys() // Asegúrate de invocar la función getSubFamilys
            .then(() => {
              this.wizardOnDisplay = "subfamily";
              this.$swal.close();
            })
            .catch((error) => {
              this.$swal.close();
              console.error("Error al obtener las familias:", error);
            });
          break;
        case "shift":
          this.getFamilys() // Asegúrate de invocar la función getSubFamilys
            .then(() => {
              this.wizardOnDisplay = "shift";
            })
            .catch((error) => {
              this.$swal.close();
              console.error("Error al obtener las familias:", error);
            });
          break;

        default:
          break;
      }
    },
    async showSwal(step, planWizard) {
      //plans - familys - subfamilys - shifts
      let newFam;
      let response;
      let swalHTML;
      let swalTitle;
      switch (step) {
        case "familys":
          swalHTML = `<div class="form-group">
            <input id="input-field" type="text" v-model="createFam" class="form-control" />
            </div>`;
          swalTitle = "Nueva Familia";
          break;
        case "subfamilys":
          swalHTML = `<div class="form-group">
            <input id="input-field" type="text" v-model="createSubFam" class="form-control" />
            </div>`;
          swalTitle = "Nueva Sub-Familia";
          break;
        case "shifts":
          swalHTML = `<div class="form-group">
            <input id="input-field" type="text" v-model="createShift" class="form-control" />
            </div>`;
          swalTitle = "Nuevo Turno";
          break;

        default:
          break;
      }
      const swalWithBootstrapButtons9 = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons9
        .fire({
          title: swalTitle,
          html: swalHTML,
          showCancelButton: true,
        })
        .then((res) => {
          if (res.isConfirmed) {
            newFam = document.getElementById("input-field").value;

            switch (step) {
              case "familys":
                this.insertFamily(newFam).then((res) => {
                  this.familys.unshift(res);
                  if (planWizard) {
                    this.planCreatorSaveFamily(res);
                  }
                });
                break;
              case "subfamilys":
                this.insertSubFamily(newFam).then((res) => {
                  this.subFamilys.unshift(res);
                  if (planWizard) {
                    this.planCreatorSaveSubFamily(res);
                  }
                });
                break;
              case "shifts":
                this.insertShift(newFam).then((res) => {
                  if (planWizard) {
                    this.shifts.unshift(res);
                  }
                });
                break;

              default:
                break;
            }
          }
        });
    },

    async submitNewShiftModal() {
      let isWizard = this.$refs.plansWizard ? true : false;
      if (!isWizard) {
        this.wizardOnDisplay = "shift";
      }
      let newShift = this.newShift;
      let errArray = [];
      if (!this.$refs.plansWizard) {
        this.$swal.fire({
          title: "Cargando...",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
      }
      const hrRegEx = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
      Object.keys(newShift).forEach((key) => {
        if (key.includes("Hora")) {
          let value = newShift[key];
          if (!hrRegEx.test(value)) {
            errArray.push(key);
          }
        } else if (key === "descripcionTurno") {
          let value = newShift[key];
          if (!value || typeof value !== "string") {
            errArray.push(key);
          }
        } else {
          if (typeof newShift[key] !== "boolean") {
            errArray.push(key);
          }
        }
      });
      if (errArray.length > 0) {
        let joinErrorArray = errArray.join(", ");
        console.error(`Campos con un valor invalido`);
        this.$swal
          .fire({
            title: "ERROR :(!",
            icon: "error",
            text: `1 o más campos mal ingresados`,
            showConfirmButton: true,
          })
          .then(() => {
            this.$refs.shiftFastCreator.closeModal();
            this.$swal.fire({
              title: "Cargando",
              allowOutsideClick: false,
              showConfirmButton: false,
              willOpen: () => {
                this.$swal.showLoading();
              },
            });
            Promise.all([this.getShiftResum()]).then(() => {
              this.$swal.close();
            });
          });
      } else {
        await this.insertShift(newShift).then((res) => {
          const { empresa, _id, ...createdShift } = res;
          // console.log("createdShift");
          // console.log(createdShift);
          this.shifts.push(res);
          // this.selectedShift = createdShift
          if (this.$refs.plansWizard) {
            this.planCreatorSaveShift(createdShift);
          } else {
            this.$swal.close();
            this.$swal.fire({
              title: "Exito!",
              icon: "success",
              text: `El Turno ${newShift.descripcionTurno} ha sido creado.`,
              showConfirmButton: false,
              confirmButtonColor: "#6bd098",
              willOpen: () => {
                this.$swal.showLoading();
              },
            });

            Promise.all([this.getShiftResum()]).then(() => {
              this.$swal.close();
            });
          }
          this.$refs.shiftFastCreator.closeModal();
        });
      }
      // console.log(this.newShift);
    },
    cancelNewShiftModal() {
      this.newShift = {
        lunesAutorizado: false,
        martesAutorizado: false,
        miercolesAutorizado: false,
        juevesAutorizado: false,
        viernesAutorizado: false,
        sabadoAutorizado: false,
        domingoAutorizado: false,
        descripcionTurno: "",
        lunesHoraInicio: "00:00:00",
        lunesHoraTermino: "23:59:59",
        martesHoraInicio: "00:00:00",
        martesHoraTermino: "23:59:59",
        miercolesHoraInicio: "00:00:00",
        miercolesHoraTermino: "23:59:59",
        juevesHoraInicio: "00:00:00",
        juevesHoraTermino: "23:59:59",
        viernesHoraInicio: "00:00:00",
        viernesHoraTermino: "23:59:59",
        sabadoHoraInicio: "00:00:00",
        sabadoHoraTermino: "23:59:59",
        domingoHoraInicio: "00:00:00",
        domingoHoraTermino: "23:59:59",
      };
      this.$refs.shiftFastCreator.closeModal();
    },
    handleTimeChange(key) {
      const hrRegEx = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
      if (!hrRegEx.test(this.newShift[key])) {
        this.newShift[key] = `${this.newShift[key]}:00`;
      }
    },
    handleShiftCreationModalClose() {
      // console.log("Modal Cerrado");
      this.newShift = {
        lunesAutorizado: false,
        martesAutorizado: false,
        miercolesAutorizado: false,
        juevesAutorizado: false,
        viernesAutorizado: false,
        sabadoAutorizado: false,
        domingoAutorizado: false,
        descripcionTurno: "",
        lunesHoraInicio: "00:00:00",
        lunesHoraTermino: "23:59:59",
        martesHoraInicio: "00:00:00",
        martesHoraTermino: "23:59:59",
        miercolesHoraInicio: "00:00:00",
        miercolesHoraTermino: "23:59:59",
        juevesHoraInicio: "00:00:00",
        juevesHoraTermino: "23:59:59",
        viernesHoraInicio: "00:00:00",
        viernesHoraTermino: "23:59:59",
        sabadoHoraInicio: "00:00:00",
        sabadoHoraTermino: "23:59:59",
        domingoHoraInicio: "00:00:00",
        domingoHoraTermino: "23:59:59",
      };
    },
    async handleNewPlanSave() {
      // console.log("[handleNewPlanSave]");
      var errorArray = [];

      let formatedPlan = this.newPlan;
      this.$swal.fire({
        title: "Cargando",
        text: `Creando plan`,
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });

      formatedPlan.turno = { ...this.selectedShift };
      // Validado Enteros
      formatedPlan.valor = !formatedPlan.valor
        ? 0
        : parseFloat(formatedPlan.valor);
      formatedPlan.sesionesLimite = !formatedPlan.sesionesLimite
        ? 0
        : parseInt(formatedPlan.sesionesLimite);
      formatedPlan.valorMatricula = !formatedPlan.valorMatricula
        ? 0
        : parseFloat(formatedPlan.valorMatricula);
      formatedPlan.duracion = !formatedPlan.duracion
        ? 0
        : parseInt(formatedPlan.duracion);
      formatedPlan.diasPermitidoCongelar = !formatedPlan.diasPermitidoCongelar
        ? 0
        : parseInt(formatedPlan.diasPermitidoCongelar);
      formatedPlan.diasMesNoCalendario = !formatedPlan.diasMesNoCalendario
        ? 0
        : parseInt(formatedPlan.diasMesNoCalendario);
      formatedPlan.expiracionRenovacion = !formatedPlan.expiracionRenovacion
        ? 0
        : parseInt(formatedPlan.expiracionRenovacion);
      formatedPlan.nombreFamilia = this.newPlanProps.famName;
      formatedPlan.nombreSubFamilia = this.newPlanProps.subFamName;
      formatedPlan.turno.idTurno = !formatedPlan.turno.id
        ? 0
        : parseInt(formatedPlan.turno.id);
      formatedPlan.habilitarVentaMobile = false; //Opción oculta hasta que se habilite la APP de socios

      if (formatedPlan.sucursalesHabilitadas.length === 0) {
        errorArray.push("Debes seleccionar sucursal para tu plan");
      }
      if (!formatedPlan.descripcion) {
        errorArray.push("Debes ingresar un nombre valido para tu plan");
      }
      if (isNaN(`${formatedPlan.valor}`)) {
        errorArray.push(
          "Debes ingresar un numero valido como valor de tu plan"
        );
      }
      if (isNaN(`${formatedPlan.turno.idTurno}`)) {
        errorArray.push(
          "Debes ingresar un numero valido como valor de tu plan"
        );
        this.$swal
          .fire({
            title: "Ups!",
            text: "Hubo un problema al seleccionar un turno, por favor vuelve a intentarlo",
            icon: "warning",
            confirmButtonColor: `#6bd098`,
          })
          .then(() => {
            this.changeWizardIndex = 2;
          });
        return;
      }

      if (errorArray.length === 0) {
        try {
          const response = await this.insertNewPlan(formatedPlan)
            .then((res) => {
              // console.log("res++++++++++++++++++++");
              // console.log(res);
              // console.log(response);
              if (response) {
                this.$swal.close();
                this.$swal
                  .fire({
                    title: "Listo!",
                    html: `<p>El plan "${formatedPlan.descripcion}" ya está disponible.</p>`,
                    html: `<p>Necesitas crear otro?</p>`,
                    icon: "success",
                    showCancelButton: true,
                    confirmButtonText: "SI",
                    cancelButtonText: "NO",
                    customClass: {
                      confirmButton: "btn-success",
                      cancelButton: "btn btn-success",
                    },
                  })
                  .then((res) => {
                    if (res.isConfirmed) {
                      this.cancelPlansWizard();
                    } else {
                      this.$router.push("/plans/plansviewer");
                    }
                    return response;
                  });
              } else {
                // console.log("reswrrsdadsadsadsadsadas");
                // console.log(response);
              }
              // console.log(res);
            })
            .catch((ex) => {
              console.error(ex.message);
              this.$swal.close();
              this.$swal
                .fire({
                  title: "ERROR",
                  text: ex.message,
                  icon: "error",
                })
                .then((res) => {
                  if (res.isConfirmed) {
                    this.cancelPlansWizard();
                  }
                });
            });
          return;
        } catch (error) {
          console.error(error);
          this.$swal.fire({
            title: "Error!",
            text:
              error.response &&
              error.response.data &&
              error.response.data.Response
                ? error.response.data.Response.Resultado.MensajeServicio
                : error.message,
            icon: "error",
            confirmButtonColor: "#eb6532",
          });
        }
      } else {
        this.$swal.close();
        const errorString =
          errorArray.length > 1 ? errorArray.join(", ") : errorArray[0];

        this.$swal.fire({
          title: "Hay un problema con tu plan!",
          text: errorString,
          icon: "warning",
          showConfirmButton: true,
        });
      }

      // console.log(formatedPlan);
    },
    async insertNewPlan(plan) {
      // console.log("plan creado");
      // console.log(plan);
      const response = this.$MasterControlAPI
        .post("", {
          Header: {
            Operacion: "/user/insertar/plan",
          },
          Auth: {
            Token: sessionStorage.getItem("jCxbraoQeD"),
          },
          Parameters: {},
          Body: { ...plan },
        })
        .then((resp) => {
          this.$swal.close();
          this.$swal
            .fire({
              title: "Listo!",
              html: `<p>El plan "${plan.descripcion}" ya está disponible.</p>`,
              html: `<p>Necesitas crear otro?</p>`,
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "SI",
              cancelButtonText: "NO",
              customClass: {
                confirmButton: "btn-success",
                cancelButton: "btn btn-success",
              },
            })
            .then((res) => {
              if (res.isConfirmed) {
                this.cancelPlansWizard();
              } else {
                this.$router.push("/plans/plansviewer");
              }
              return response;
            });
        })
        .catch((ex) => {
          console.error(ex);
          this.$swal.close();
          this.$swal
            .fire({
              title: "ERROR",
              text:
                ex.response && ex.response.data
                  ? ex.response.data.Response.Resultado.MensajeServicio
                  : "Ha fallado la creación del plan",
              icon: "error",
            })
            .then((res) => {
              this.cancelPlansWizard();
            });
          return "Error";
        });
      // console.log("response=-======");
      // console.log(response);
      // return response;
      // } catch (error) {
      //   console.error("insertNewPlan");
      //   console.error(error.message);
      //   return error;
      // }
      return response;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.run) {
        const query = to.query.run;
        if (query === "WHbUjdv3TG") {
          vm.modals.newShiftModal = true;
        } else {
          vm.initPlansWizard(query);
        }
      }
    });
  },
  mounted() {
    // Ya no es necesario hacer toggle del sidebar porque ahora inicia expandido por defecto
    // if (this.$sidebar.isMinimized) {
    //   this.$sidebar.toggleMinimize();
    // }
    this.branches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
    Promise.all([this.getPlansCatalogs()]).then((res) => {
      this.$swal.close();
      this.isLoaded = true;
      // this.newPlan.unidadDuracionPlan = this.plansCatalogs.unidadDuracion[0].glosa;
      // this.newPlan.convenio = this.plansCatalogs.convenio[0].glosa;
      // this.newPlan.unidadExpiracionRenovacion =
      //   this.plansCatalogs.unidadExpiracionRenovacion[0].glosa;
    });
  },
  beforeDestroy() {
    // Modal de carga removido - causaba problemas de persistencia
    // al navegar entre componentes. El componente de destino maneja
    // su propia carga con spinners internos.
  },
};
</script>

<style scoped>
.wizard > *:not(:first-child) {
  min-height: 400px;
}
.card--big {
  min-height: 500px;
}
#cancelFAB {
  z-index: 400;
}
.table-body {
  display: block; /* Permite que el tbody tenga su propio bloque de formato */
  max-height: 300px; /* Hereda la altura máxima del contenedor padre */
  overflow-y: auto; /* Agrega una barra de desplazamiento vertical si es necesario */
}

/* Mantén los estilos originales y agrega los siguientes para vistas móviles */
@media (max-width: 768px) {
  .wizard-buttons-responsive {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .wizard-buttons-responsive .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  /* Ajuste para PASO 1 (Familia) */
  .wizard-plans-fam {
    flex-direction: column !important;
    align-items: stretch !important;
  }
  .wizard-plans-fam .col {
    margin-bottom: 1rem;
  }

  /* Ajuste para PASO 2 (Sub-Familia) */
  .wizard-plans-subfam {
    flex-direction: column !important;
    align-items: stretch !important;
  }
  .wizard-plans-subfam .col {
    margin-bottom: 1rem;
  }

  /* Ajuste para PASO 3 (Turno) */
  .wizard-plans-shift {
    flex-direction: column !important;
    align-items: stretch !important;
  }
  .wizard-plans-shift .col {
    margin-bottom: 1rem;
  }

  /* Ajustes para mejorar los títulos en dispositivos móviles */
  .wizard-step-title {
    font-size: 1.2rem;
    display: inline-block;
    margin-left: 0.5rem;
  }

  .wizard-title {
    font-size: 1.5rem;
    text-align: center;
    margin-top: 1rem;
  }

  .wizard-description {
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1rem;
  }

  /* Opcionalmente, se puede ajustar el tamaño de los iconos */
  .wizard-tab i {
    font-size: 1.5rem;
  }
}
</style>
